import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { mapStatusesToCardDetails } from "../../../../helpers/mapStatusesToCardDetails";
import {
  BackgroundCheckRequestStatus,
  IBackgroundCheckRequestResponse
} from "@wingspanhq/background-checks/dist/lib/interfaces";
import { WSEmptyStateProps } from "@wingspanhq/fe-component-library/dist/lib/components/WSEmptyState/WSEmptyState";

export const payeeBackgroundCheckRenderCardDescription = (
  requirement: IRequirementResponse,
  backgroundCheck?: IBackgroundCheckRequestResponse
) => {
  const descriptions: Record<BackgroundCheckRequestStatus, WSEmptyStateProps> =
    {
      [BackgroundCheckRequestStatus.New]: {
        type: "search",
        title: "Background check is pending",
        description: "Waiting for the contractor to start the process."
      },
      [BackgroundCheckRequestStatus.Pending]: {
        type: "search",
        title: "Background check is pending",
        description:
          "The contractor received an email with instructions and a background check invite link that expires 14 days after the initial invite."
      },
      [BackgroundCheckRequestStatus.Processing]: {
        type: "search",
        title: "The background check is being processed",
        description:
          "This typically takes 1-3 business days. You will be notified when it is complete."
      },
      [BackgroundCheckRequestStatus.Success]: {
        type: "done",
        title: "The background check is complete",
        description:
          "The report can be accessed in the background check portal."
      },
      [BackgroundCheckRequestStatus.Failed]: {
        type: "search",
        title: "Something went wrong with the background check",
        description:
          "Please review the report if available. You can restart the process or mark requirement as complete."
      }
    };

  return mapStatusesToCardDetails({
    requirement,
    documentStatus: backgroundCheck?.status || BackgroundCheckRequestStatus.New,
    documentStatuses: descriptions,
    pendingApprovalStatus: null,
    rejectedStatus: null,
    approvedStatus: null
  });
};
